// extracted by mini-css-extract-plugin
module.exports = {"icon":"TrustBannerIcon_icon__YaBcU"};